import { useState } from "react";
import StorageList from "./StorageList";
import { useSearchParams } from "react-router";
import { StorageHistory } from "./StorageHistory";
import { MdFormatListBulleted, MdHistory } from "react-icons/md";

enum Show_mode {
  list = "Liste",
  history = "Historiques",
}

const SHOW_MODE_OPTIONS = [
  {
    icon: (
      <MdFormatListBulleted
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.list,
  },
  {
    icon: (
      <MdHistory
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.history,
  },
];

export const StoragePages = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialView = searchParams.get("mode") || Show_mode.list;

  const [selectedMode, setSelectedMode] = useState<string>(initialView);

  const handleChangeViewMode = () => {
    const nextMode =
      selectedMode === Show_mode.list
        ? Show_mode.history
        : Show_mode.list;
  
    setSelectedMode(nextMode);
    setSearchParams({ mode: nextMode });
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end ">
        {/* <TitleHeader
          title={
            selectedMode === Show_mode.list
              ? "Magasins"
              : "Historiques des magasins"
          }
        /> */}

        {/* <div className=" ">
          <div className="flex-full mt-4">
            <Segmented
              // size={size}
              shape="round"
              value={selectedMode}
              onChange={handleChangeViewMode}
              options={SHOW_MODE_OPTIONS}
            />
            {/* <Radio.Group
              block
              options={SHOW_MODE_OPTIONS}
              optionType="button"
              buttonStyle="solid"
              // defaultValue={}
              value={selectedMode}
              onChange={handleChangeViewMode}
            />
          </div>
        </div> 
        <div className={style.button__custom} onClick={handleChangeViewMode}>
          {selectedMode === Show_mode.list
            ? <><MdHistory size={18} /> Voir l'historique des mouvements</>
            : <><IoReturnDownBack size={18} /> Voir la liste des entreposages</>}
        </div>*/}
      </div>
      {selectedMode === Show_mode.list ? <StorageList /> : <StorageHistory />}
    </div>
  );
};
